<template lang="pug">
Auth(@loggedIn="onLoggedIn"
  :redirectWithLoginFailed="true")
  Header(:content="headerContent")
  div.wrap-edit-profile
    ModuleEditProfile(ref="editProfile"
      v-if="user" :user="user")
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.wrap-edit-profile {
  width: 100%;
  min-height: $device_height;
}
</style>

<script>
import database from '@/database'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth, mapActions: mapActionsAuth } = createNamespacedHelpers('auth')
import Auth from '@/components/shared/Auth'
import Header from '@/components/shared/Header'
import ModuleEditProfile from '@/components/module/ModuleEditProfile'

export default {
  components: {
    Auth,
    Header,
    ModuleEditProfile
  },
  data () {
    return {
      headerContent: {
        title: 'プロフィール編集',
        left: {
          icon: 'mdi-close',
          action: this.onClose
        },
        right: {
          label: 'Save',
          color: '#1DC1AC', // this.pallete.$active_color,
          action: this.onSave
        }
      },
      user: null,
      isSaving: false
    }
  },
  computed: {
    ...mapStateAuth(['uid'])
  },
  // async created () {
  //   this.user = await database.userCollection().findById(this.uid)
  // },
  methods: {
    async onLoggedIn () {
      this.user = await database.userCollection().findById(this.uid)
    },
    async onSave () {
      if (this.isSaving) return
      this.isSaving = true

      const moduleEditProfile = this.$refs.editProfile
      const userObj = {
        name: moduleEditProfile.name,
        profile: moduleEditProfile.profile,
        iconPhotoURL: moduleEditProfile.iconPhotoURL,
        updatedAt: new Date()
      }

      if (!userObj.name) {
        this.$root.$emit('showNavigationMessage', {
          message: '名前を入力してください', showOK: true
        })
        this.isSaving = false
        return
      }
      await database.userCollection().update(this.uid, userObj)

      this.isSaving = false
      
      this.$root.$emit('showNavigationMessage', {
        message: '保存しました', showOK: true
      })
      this.$router.push(`/user/${this.uid}`)
    },
    onClose () {
      this.$router.go(-1)
    }
  }
}
</script>
